import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { UserAccountStatusCard } from './UserAccountStatusCard.tsx';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { StatusOK, StatusWarning, TableColumn } from '@backstage/core-components';
import { CatalogTableRow } from '@backstage/plugin-catalog/alpha';
import { ACCOUNT_ENABLED_ANNOTATION } from './constant.tsx';

export const userStatusColumn: TableColumn<CatalogTableRow> = {
  title: 'Status',
  field: `entity.metadata.annotations['${ACCOUNT_ENABLED_ANNOTATION}']`,
  width: 'auto',
  customSort: (a, b) => {
    const aEnabled =
      a.entity.metadata.annotations?.[ACCOUNT_ENABLED_ANNOTATION] !== 'false';
    const bEnabled =
      b.entity.metadata.annotations?.[ACCOUNT_ENABLED_ANNOTATION] !== 'false';
    return Number(bEnabled) - Number(aEnabled);
  },
  render: (row: CatalogTableRow) => {
    const enabled =
      row.entity.metadata.annotations?.[ACCOUNT_ENABLED_ANNOTATION] !== 'false';
    return (
      <span
        style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13 }}
      >
        {enabled ? (
          <>
            <StatusOK />
            Active
          </>
        ) : (
          <>
            <StatusWarning />
            Inactive
          </>
        )}
      </span>
    );
  },
};

const userAccountStatusCard = EntityCardBlueprint.make({
  name: 'user-account-status',
  params: {
    filter: 'kind:user',
    loader: async () => <UserAccountStatusCard />,
  },
});

export const usersModule = createFrontendModule({
  pluginId: 'app',
  extensions: [userAccountStatusCard],
});
